module.exports = __webpack_public_path__ + "img/WP2023-Dubai1.767e172e.jpg";